// shakir is uploading data...

import PageBanner from "@/src/components/PageBanner";
import Layout from "@/src/layout/Layout";
import { client, urlFor } from "../lib/client";
import formatDateToCustomFormat from "../utils/dateFormatter";
import { NextSeo, ArticleJsonLd } from 'next-seo';
import Link from "next/link";
import { Fragment, useState } from "react";

const POSTS_PER_PAGE = 4;

const Blog = ({
  BlogPageT,
  fetchFooter,
  fetchHeader,
  fBlogs,
  fHeaderMenuData,
  seoData
}) => {
  const {
    canonical, seo_image, jsonLtd, metaDescription, metaTitle, type, url
  } = seoData;

   // State for current page
   const [currentPage, setCurrentPage] = useState(1);

   // Total pages calculation
   const totalPages = Math.ceil(fBlogs.length / POSTS_PER_PAGE);
 
   // Calculate the start and end index for posts on the current page
   const startIndex = (currentPage - 1) * POSTS_PER_PAGE;
   const endIndex = startIndex + POSTS_PER_PAGE;
 
   // Get posts for the current page
   const currentPosts = fBlogs.slice(startIndex, endIndex);
 
   // Function to change page
   const changePage = (pageNumber) => {
     setCurrentPage(pageNumber);
   };
 


console.log(BlogPageT);
  return (
    <Fragment>
         <NextSeo
            title={metaTitle}
            description={metaDescription}
            canonical={canonical}
            robots="index, follow"
            
            openGraph={{
              type: type,
              url: url,
              title: metaTitle,
              description: metaDescription,
              image: urlFor(seo_image).url(),
              
            }} 
        />
        <ArticleJsonLd
     dataArray={JSON?.parse(jsonLtd)}
        />

    <Layout footerData={fetchFooter} headerData={fetchHeader} menuData={fHeaderMenuData} >
      {/* Page Banner Start */}
      <PageBanner pageName={BlogPageT?.title} />
      {/* Page Banner End */}
      {/* Blog Page Area start */}
      <section className="blog-page-area py-130 rpy-100 rel z-1">
        <div className="container container-1290">
          <div className="row">
            {currentPosts.map((blog, index) => (

               <div key={index} className="col-xl-4 col-md-6">
                <div className="blog-item wow fadeInUp delay-0-2s">
                <div className="image">
    <img src={urlFor(blog.mainImage)} alt={blog.mainImage.alt} />
  </div>
  <ul className="blog-meta">
    <li>
      <i className="far fa-calendar-alt" />
      <a href="#"> {formatDateToCustomFormat(blog.publishedAt)} </a>
    </li>
    <li>
      <i className="far fa-comments" />
      <a href="#">Comment {blog.comments?.length }</a>
    </li>
  </ul>
  <hr />
  <h4>
    <Link legacyBehavior href={`/insights/${blog.slug.current}`}  >
      <a> {blog.title} </a>
    </Link>
  </h4>
  <Link legacyBehavior href={`/insights/${blog.slug.current}`}>
    <a className="read-more">
      Read More <i className="far fa-arrow-right" />
    </a>
  </Link>
</div>
</div>

            ))}



            <div className="col-lg-12">
              <ul className="pagination mt-10 flex-wrap justify-content-center wow fadeInUp delay-0-2s">
              {Array.from({ length: totalPages }, (_, i) => (

<>
                <li className="page-item">
                  <p style={{ background: i + 1 === currentPage ? 'white' : '' }} key={i} onClick={() => changePage(i + 1)} className="page-link">
                  {i + 1}
                  </p>
                                  </li>

                </>
  ))}
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* Blog Page Area end */}
      {/* footer area start */}
    </Layout>
    </Fragment>
  );
};

export const getServerSideProps = async () => {

  // fetching layouts
  const queryForFooter = `*[ _type == "Footer"  ][0]`;
  const fetchFooter = await client.fetch(queryForFooter);

  const queryForHeader = `*[ _type == "Header"  ][0]`;
  const fetchHeader = await client.fetch(queryForHeader);

  // blog section

  const BlogsQ = `*[ _type == "Blog"]
  {
      _id,
        title,
        content,
        mainImage,
        publishedAt,
        slug,
        seo,
        author
  }`
  const fBlogs = await client.fetch(BlogsQ);

  const BlogPageTQ = `*[ _type == "blogPage"][0]`
  const BlogPageT = await client.fetch(BlogPageTQ);


          // fetching header data
          const headMenuData = `*[ _type == "Header"  ]{
            menu_items[]->{
                     title,
                     slug,
                     menu_name,
                     menu_name_number,
           }
         }[0]`;
          const fHeaderMenuData =  await client.fetch(headMenuData);
          const headerDataForMenu = fHeaderMenuData.menu_items;

// fetch seo data for main pages
  const queryForGridSeo = `
  *[_type == "Blog" && grid_page_seo != null]{
    "seo-main": grid_page_seo{
      ...,
    },
  }[0]
    
  `;
  const fBlogSeoQuery = await client.fetch(queryForGridSeo); 
  const seoData = fBlogSeoQuery["seo-main"];

  return {
    props: {
      BlogPageT,
      fetchFooter,
      fetchHeader,
      fBlogs,
      fHeaderMenuData: headerDataForMenu,
      seoData

    },
  };

}
export default Blog;
